import { defineComponent as _defineComponent } from 'vue'
import { Shift } from '@/../api/v1';
import SlidePanel from '@/components/interface/SlidePanel.vue';
import BottomSheet from '@/components/modal/BottomSheet.vue';
import { ShiftActionExcludeOptions } from '@/lib/actions/shiftActionsComposable';
import { useOpen } from '@/lib/composition/dialog';
import { EmitCreateShiftData } from '@/lib/schedule-v2/scheduleV2Actions';
import { viewport } from '@/util/windowFunctions';
import ShiftDetailsSheetContent from './components/ShiftDetailsSheetContent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShiftDetailsSheet',
  props: {
    value: { type: Boolean },
    shift: null,
    employeeActions: { type: Boolean, default: false },
    excludedActions: { default: () => [] },
    showManagementDetails: { type: Boolean, default: true },
    matchingShiftIds: { default: () => [] }
  },
  emits: ["input", "close", "createShift"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'close'): void;
  (e: 'createShift', value: EmitCreateShiftData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, shift: Shift, employeeActions: boolean, excludedActions: ShiftActionExcludeOptions, showManagementDetails: boolean, matchingShiftIds: number[] }




const open = useOpen(() => props.value, emit);

return { __sfc: true,props, emit, open, SlidePanel, BottomSheet, viewport, ShiftDetailsSheetContent }
}

})